// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"532":"styles","678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"532":"959bcfd01e5d5b044e84","678":"1bb1bb093ea6dc44daf6","883":"c845c77c3bb0f8d360d4"}[chunkId] + ".js";
};